var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c(
        "label",
        { attrs: { for: _vm.uid + "triggerDistanceTraveledDutyKilometers" } },
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "map.gps.tracker.model.triggerDistanceTraveledDutyKilometers"
              )
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.triggerDistanceTraveledDutyKilometers,
            expression: "triggerDistanceTraveledDutyKilometers"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "number",
          id: _vm.uid + "triggerDistanceTraveledDutyKilometers",
          min: "-1",
          max: "50000",
          step: "1",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.triggerDistanceTraveledDutyKilometers },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.triggerDistanceTraveledDutyKilometers = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c(
        "label",
        {
          attrs: { for: _vm.uid + "triggerDistanceTraveledDutySetPointMinutes" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "map.gps.tracker.model.triggerDistanceTraveledDutySetPointMinutes"
              )
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.triggerDistanceTraveledDutySetPointMinutes,
            expression: "triggerDistanceTraveledDutySetPointMinutes"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "number",
          id: _vm.uid + "triggerDistanceTraveledDutySetPointMinutes",
          min: "-1",
          max: "10000",
          step: "1",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.triggerDistanceTraveledDutySetPointMinutes },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.triggerDistanceTraveledDutySetPointMinutes = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.triggerDistanceTraveledDutyKilometers > 0 &&
              _vm.triggerDistanceTraveledDutySetPointMinutes > 0,
            expression:
              "triggerDistanceTraveledDutyKilometers > 0 && triggerDistanceTraveledDutySetPointMinutes > 0"
          }
        ],
        staticClass: "form-group"
      },
      [
        _c(
          "label",
          { attrs: { for: _vm.uid + "triggerDistanceTraveledDutyId" } },
          [
            _vm._v(
              _vm._s(
                _vm.$t("map.gps.tracker.model.triggerDistanceTraveledDutyId")
              )
            )
          ]
        ),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            id: _vm.uid + "triggerDistanceTraveledDutyId",
            options: _vm.dutyStore.duties,
            label: "title",
            reduce: d => d.dutyId,
            disabled: _vm.disabled
          },
          model: {
            value: _vm.tracker.triggerDistanceTraveledDutyId,
            callback: function($$v) {
              _vm.$set(_vm.tracker, "triggerDistanceTraveledDutyId", $$v)
            },
            expression: "tracker.triggerDistanceTraveledDutyId"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }